module.exports = __webpack_public_path__ + "media/konrad_mantel.f1cf3896.mp3";